import Navbar from './components/Navbar';
import Hero from './components/Hero';
import RankTopics from './components/RankTopics';
import Feed from './components/Feed';
import VideoWall from './components/VideoWall';
import Packs from './components/Packs';
import Channels from './components/Channels';
import Footer from './components/Footer';

function CtaBand() {
  return (
    <section className="relative overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=wide%20panoramic%20collage%20of%20concert%20flash%20lights%20and%20press%20camera%20lens%20flares%20in%20deep%20crimson%20and%20amber%20tones%2C%20dramatic%20stage%20glare%20with%20confetti%20silhouettes%2C%20moody%20editorial%20atmosphere%2C%20grainy%20film%20texture%2C%20high-contrast%2C%20abstract%20noise%2C%20no%20identifiable%20people%2C%20warm%20dark%20background%20with%20strong%20contrast&width=1800&height=460&seq=cta-band-51&orientation=landscape"
        alt="五一黑料每日更新资源合集"
        className="absolute inset-0 h-full w-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/85 via-foreground-950/55 to-foreground-950/35"></div>
      <div className="relative mx-auto flex max-w-7xl flex-col items-start px-4 md:px-6 py-10 md:py-16">
        <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-500/95 px-3 py-1 text-xs font-bold text-foreground-950">
          <i className="ri-download-cloud-2-fill"></i> 网盘打包 · 一键直达
        </span>
        <h2 className="mt-4 max-w-2xl font-heading text-2xl md:text-4xl font-black text-background-50 text-balance">
          每日整理打包资源，想看的一次看个够
        </h2>
        <p className="mt-3 max-w-xl text-sm text-background-100/90">
          图文、视频、动图弹幕与完整长文分门别类，省去东翻西找的麻烦，按图索骥即可。
        </p>
        <a
          href="#packs"
          className="mt-6 inline-flex whitespace-nowrap items-center gap-2 rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-400"
        >
          <i className="ri-download-2-line text-lg"></i> 进入打包资源区
          <i className="ri-arrow-right-line"></i>
        </a>
      </div>
    </section>
  );
}

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 text-foreground-900">
      <Navbar />
      <main>
        <Hero />
        <RankTopics />
        <Feed />
        <VideoWall />
        <CtaBand />
        <Packs />
        <Channels />
      </main>
      <Footer />
    </div>
  );
}